<template>
  <div class="">
    <Breadcrumbs :classes="{ menu: true }"/>
    <div class="container-fluid table-category mb-4">
      <div v-for="categoryPair in categoryTimeprice" :key="categoryPair[0].category.name" class="category-row row d-flex flex-wrap ">
        <div v-for="category in categoryPair" :key="category.category.name" class="timeprice-card col-xs-12 col-sm-6">
          <div class="card card-timeprice">
            <div class="card-body h-100">
              <div class="category d-flex flex-direction-column h-100">
                <div class="category-header d-flex py-1 justify-content-between w-100">
                  <div class="category-title">
                    <p :class="['text-permalink-home text-title', category.category.class]">{{ category.category.name }}</p>
                  </div>
                  <div class="category-number min-w-50">
                    <p class="text-permalink-home text-title bold-text">{{ category.timeprices.length }}件</p>
                  </div>
                </div>
                <div class="category-description">
                  <div class="break-words">
                    <span class="text-category mt-2">{{ category.category.description }}</span>
                  </div>
                </div>
                <div class="text-content d-flex">
                  <button class="btn-choose-category text-center scroll-top mt-4"
                          @click="chooseCategory(category)">
                    <span>選択</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-wrapper py-5">
      <div class="container">
        <div class="footer-buttons">
          <span class="back-step" @click="goBack">&lt; 戻る</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from './Breadcrumbs.vue';

export default {
  name: 'ChooseCategory',
  components: {
    Breadcrumbs
  },
  props: {
    categoryTimeprices: {
      type: Array,
      required: true
    },
    otherTimeprices: {
      type: Array,
      required: true
    }
  },
  computed: {
    categoryTimeprice() {
      const pairs = [];
      for (let i = 0; i < this.categoryTimeprices.length; i += 2) {
        pairs.push(this.categoryTimeprices.slice(i, i + 2));
      }
      if (pairs.length > 0 && pairs[pairs.length - 1].length === 1) {
        pairs[pairs.length - 1].push({
          category: {name: 'その他', description: '', class: 'text-bold font-hiraginoSans-w6'},
          timeprices: this.otherTimeprices
        });
      } else {
        pairs.push([{
          category: {name: 'その他', description: '', class: 'text-bold font-hiraginoSans-w6'},
          timeprices: this.otherTimeprices
        }]);
      }
      return pairs;
    }
  },
  methods: {
    chooseCategory(category) {
      this.$emit('showChooseTimePrice', category.timeprices);
    },
    goBack() {
      this.$emit('goBack');
    }
  }
};
</script>

<style scoped>
.timeprice-card {
  padding-bottom: 20px;
}

.category-description {
  flex: 1;
}

.card-timeprice {
  height: 100%;
}

.category-row {
  margin-left: -15px;
  margin-right: -15px;
}

@media (max-width: 768px) {
  .table-category {
    padding-left: 0;
    padding-right: 0;

    .card {
      height: auto;
    }
    .timeprice-card {
      padding-bottom: 0;
    }
  }
}
</style>
